/**
 * Reserved for auth-route guards. KYC pending blocking is handled by KycPendingOverlay.
 */
const KycGate = () => null;

export default KycGate;
